// internal
import { axios, def, handleError, handleResponse } from './internal';

// client-shared
import { storage } from '@goldblack/client-storage';

function AdminObjectList(service, type) {
    storage.transience.setState(`${service}.${type}.loading`, true);

    axios
        .post('/api/admin_object_list', {
            service,
            type,
        })
        .then((res) => {
            switch (res.data.code) {
                case def.ErrorCode.OK: {
                    const items = res.data.data[type];
                    const meta = res.data.data[`${type}Meta`];
                    storage.transience.setState(`${service}.${type}.data`, items);
                    if (meta !== undefined) storage.transience.setState(`${service}.${type}.meta`, meta);
                    break;
                }
                default:
                    handleResponse(res);
                    break;
            }
        })
        .catch((err) => {
            handleError(err);
        })
        .finally(() => {
            storage.transience.setState(`${service}.${type}.loading`, false);
        });
}

export { AdminObjectList };
